import { Component, OnInit, ViewChild } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApplicationType } from 'src/api/models/application-type';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { ApplicationService,CustomerService,CeresTagService, FireForesightService, SmartIrrigationService } from 'src/api/services';


@Component({
  selector: 'app-fire-foresight-onboard',
  templateUrl: './onboard.component.html',
  styleUrls: ['./onboard.component.css']
})
export class SmartIrrigationOnBoardComponent implements OnInit {

  public applications : ApplicationType[];
  state: string;
  redirect_uri: string;
  client_id: string;
  errorMessage: string;
  
  constructor(
    private route: ActivatedRoute,
    public azureAuthService: AzureAuthService,
    public toaster: ToastrService,
    private app: ApplicationConfigService,
    private irrigation: SmartIrrigationService) { }

  ngOnInit(): void {    
    
  }

 
  completeActivation(){
    this.irrigation.SmartIrrigationPurchase(this.app.customerId).subscribe(s =>{

      this.toaster.success("Application Purchased Successfully", "Smart Irrigation")

    }, error => {
        this.errorMessage = "Error"
        this.toaster.error("Application Purchase Failed", "Smart Irrigation");
    });
    
  }
}
